module.exports = __webpack_public_path__ + "static/contrast-1a3edf9de8ce17204e4ad69528527541.png";